import Hero from "./Hero";

export default function Main() {
  return (
    <main>
      <Hero />
    </main>
  );
}
